import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M14.7,25h-4.5V14.8H0v-4.7h10.2V0h4.5v10.1H25v4.7H14.7V25z" />
    </g>
  </svg>
);
